import React from 'react';
import { useTranslation } from 'react-i18next';
import { ImplementationPackage, SubscriptionData } from '../BillingTypes';
import ImplementationRowCard from '../ImplementationRowCard';
import '../../../../style/scss/billing.scss';

interface ImplementationSelectionProps {
    implementationPackages: ImplementationPackage[];
    updatedSubscription: SubscriptionData;
    setUpdatedSubscription: React.Dispatch<React.SetStateAction<SubscriptionData>>;
};

const ImplementationSelection: React.FC<ImplementationSelectionProps> = ({
    implementationPackages, updatedSubscription, setUpdatedSubscription
}) => {
    const { t } = useTranslation();

    // Get the active implementation packages, sorted by their ordering
    const implementationOptions = implementationPackages
        .filter(implementation => implementation.is_active)
        .sort((a, b) => (a.ordering ?? 0) - (b.ordering ?? 0));

    // Toggle the selection of an implementation package, only one can be selected
    const handleImplementationToggle = (implementationPackageId: number) => {
        setUpdatedSubscription(prev => ({
            ...prev,
            implementation_package: prev.implementation_package === implementationPackageId ? null : implementationPackageId
        }));
    };

    return (
        <div className='wizard-step'>
            <div className='container-filled header-title'>
                <h2>{t('billing.general.select_implementation_header')}</h2>
                <p>{t('billing.general.select_implementation_description')}</p>
            </div>
            <div className='step-content'>
                {implementationOptions.length > 0 ? (
                    <div className='container-filled module-row-cards'>
                        {implementationOptions.map(implementation => (
                            <ImplementationRowCard
                                key={implementation.id}
                                implementationPackage={implementation}
                                selected={updatedSubscription.implementation_package === implementation.id}
                                onClick={() => handleImplementationToggle(implementation.id)}
                            />
                        ))}
                    </div>
                ) : (
                    <div className='container-filled'>
                        <p>{t('billing.general.no_implementation_available_label')}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ImplementationSelection;
